module.exports = __webpack_public_path__ + "img/save_fd.5d42d200.svg";